import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import EnhancedTableHead from './tableParts/TableHeader';
import EnhancedTableToolbar from './tableParts/TableToolbar';
import styles from './tableStyle-jss';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';

class TableCallCenterPackageList extends React.Component {
  constructor(props, context) {
    super(props, context);
    const {
      order,
      orderBy,
      selected,
      data,
      page,
      rowsPerPage,
      defaultPerPage,
      filterText
    } = this.props;

    this.state = {
      order,
      orderBy,
      selected,
      data: data,
      page,
      rowsPerPage,
      defaultPerPage,
      filterText,
    };
  }

  handleRequestSort = (event, property) => {
    const orderByAlias = property;
    let orderLet = 'desc';
    const { orderBy, order, data } = this.state;
    if (orderBy === property && order === 'desc') {
      orderLet = 'asc';
    }

    const dataAlias = orderLet === 'desc'
      ? data.sort((a, b) => (b[orderByAlias] < a[orderByAlias] ? -1 : 1))
      : data.sort((a, b) => (a[orderByAlias] < b[orderByAlias] ? -1 : 1));

    this.setState({ data: dataAlias, order: orderLet, orderBy: orderByAlias });
  };

  handleSelectAllClick = (event, checked) => {
    this.props.selectedAllPackage(checked);
    const { data } = this.state;
    if (checked) {
      this.setState({ selected: data.map(n => n.Id) });
      return;
    }
    this.setState({ selected: [] });
  };

  handleClickGetAddition = (Id) => {
    this.props.getAddition(Id);
  };

  handleClickPackagePrinted = (Id, BrandId) => {
    this.props.printedPackage(Id, BrandId);
  };

  handleClickGetPackageHistory = (Id) => {
    this.props.getPackageHistory(Id);
  };

  handleClickGetPackageEdit = (Id) => {
    this.props.getPackageEdit(Id);
  };

  handleClickSelected = (Id) => {
    this.props.selectedPackage(Id);
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  // eslint-disable-next-line
  isSelected = id => this.state.selected.indexOf(id) !== -1;

  handleUserInput(value) {
    const { data, defaultPerPage } = this.state;
    // Show all item first
    if (value !== '') {
      this.setState({ rowsPerPage: data.length });
    } else {
      this.setState({ rowsPerPage: defaultPerPage });
    }

    // Show result base on keyword
    this.setState({ filterText: value.toLowerCase() });
  }

  deleteButton(value) {
    const { selected } = this.state;
  }

  render() {
    const { classes, delete_event, Operation } = this.props;
    const {
      data,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      filterText
    } = this.state;
    const { columnData } = this.props;
    const checkcell = false;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - (page * rowsPerPage));
    const renderCell = (dataArray, keyArray) => keyArray.map((itemCell, index) => (
      (!itemCell.hidden ? (
        <TableCell align={itemCell.numeric ? 'right' : 'left'} key={index.toString()}>
          {(itemCell.id == "PackageStatus") ?
            dataArray[itemCell.id] == "0" ? <div style={{ backgroundColor: '#7f8c8d', color: 'white', padding: 10, textAlign: 'center', fontWeight: 'bold', fontSize: 15, width: 150, display: 'inherit' }}>{"Beklemede"}</div> :
              dataArray[itemCell.id] == "1" ? <div style={{ backgroundColor: '#27ae60', color: 'white', padding: 10, textAlign: 'center', fontWeight: 'bold', fontSize: 15, width: 150, display: 'inherit' }}>{"Onaylandı"}</div> :
                dataArray[itemCell.id] == "2" ? <div style={{ backgroundColor: '#8e44ad', color: 'white', padding: 10, textAlign: 'center', fontWeight: 'bold', fontSize: 15, width: 150, display: 'inherit' }}>{"Hazırlanıyor"}</div> :
                  dataArray[itemCell.id] == "3" ? <div style={{ backgroundColor: '#1abc9c', color: 'white', padding: 10, textAlign: 'center', fontWeight: 'bold', fontSize: 15, width: 150, display: 'inherit' }}>{"Yola Çıktı"}</div> :
                    dataArray[itemCell.id] == "4" ? <div style={{ backgroundColor: '#3498db', color: 'white', padding: 10, textAlign: 'center', fontWeight: 'bold', fontSize: 15, width: 150, display: 'inherit' }}>{"Teslim Edildi"}</div> :
                      dataArray[itemCell.id] == "5" ? <div style={{ backgroundColor: '#c0392b', color: 'white', padding: 10, textAlign: 'center', fontWeight: 'bold', fontSize: 15, width: 150, display: 'inherit' }}>{"İptal Edildi"}</div> : ""
            : (itemCell.id == "IsComeGet" ?
            <Tooltip title={(dataArray[itemCell.id] ? "GEL-AL SERVİS" : "PAKET SERVİS")}><Icon>{(dataArray[itemCell.id] ? "storefront" : "moped")}</Icon></Tooltip>
              : (itemCell.id == "CreationTime" ? moment(dataArray[itemCell.id]).format('HH:mm') : (dataArray[itemCell.id])))}
        </TableCell>
      ) : null)
    ));
    return (
      <div className={classes.rootTable}>
        <Grid container spacing={1}>
          <Grid item md={12}>
            <EnhancedTableToolbar
              numSelected={selected.length}
              filterText={filterText}
              onUserInput={(event) => this.handleUserInput(event)}
              title=""
              placeholder="Arama"
              delete_event={id => this.deleteButton()}
            />
          </Grid>
        </Grid>
        <div className={classes.tableWrapper}>
          <Table className={classNames(classes.table, classes.stripped, classes.hover, classes.small)}>
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              align={'center'}
              orderBy={orderBy}
              onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={data.length}
              columnData={columnData}
              checkcell={checkcell}
              Operation={Operation}
            />
            <TableBody>
              {data.slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage).map(n => {
                const isSelected = this.isSelected(n.Id);
                let a = n.CustomerNameSurname.toLowerCase() + n.AdditionCode.toLowerCase() + (n.Courrier == null ? "" : n.Courrier.toLowerCase());
                if (a.indexOf(filterText) === -1) {
                  return false;
                }
                return (
                  <TableRow
                    onClick={event => this.handleClick(event, n.Id)}
                    role="checkbox"
                    aria-checked={false}
                    tabIndex={-1}
                    key={n.Id}
                    selected={false}
                  >
                    {renderCell(n, columnData)}
                    <TableCell align={'right'} key={99}>
                      <Tooltip title="Paketi Düzenleme">
                        <IconButton disabled={n.PackageStatus == "1" || n.PackageStatus == "2" ? false : true} style={{ marginRight: 15 }} aria-label="İnformation" onClick={() => this.handleClickGetPackageEdit(n.Id)}>
                          <Icon>{"edit"}</Icon>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Paket Geçmişi">
                        <IconButton style={{ marginRight: 15 }} aria-label="İnformation" onClick={() => this.handleClickGetPackageHistory(n.Id)}>
                          <Icon>{"info"}</Icon>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Pakete Git">
                        <IconButton aria-label="Package" onClick={() => this.handleClickGetAddition(n.Id)}>
                          <Icon>{"playlist_add_check"}</Icon>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Yazdırılma Durumu">
                        <IconButton disabled={(n.PackagePrinted ? 'disabled' : '')} aria-label="Package" onClick={() => this.handleClickPackagePrinted(n.Id, n.BrandId)}>
                          <Icon style={{ color: (n.PackagePrinted ? "#27ae60" : "#c0392b") }}>{"print"}</Icon>
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 49 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

TableCallCenterPackageList.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  selected: PropTypes.array.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  defaultPerPage: PropTypes.number.isRequired,
  filterText: PropTypes.string.isRequired,
  columnData: PropTypes.array.isRequired
};

export default withStyles(styles)(TableCallCenterPackageList);
